import { Dispatch, useCallback, useEffect, SetStateAction, useRef } from 'react'
import { FormattedMessage } from 'react-intl'

import theme from 'theme_'
import {
  TERMS_AND_CONDITIONS_LINK,
  JUNIPER_TERMS_AND_CONDITIONS_LINK,
} from 'app/consts'
import { useAppDispatch, useAppSelector } from 'app/hooks'
import { Spinner, SpinnerCentered } from 'components/Loader'
import { Secondary } from 'components/Typography'
import { useHomeRouteParams } from 'features/home/hooks'
import { upcomingInvoiceSelectors } from '../../selectors'
import CheckoutAmounts from '../CheckoutAmounts'
import { checkoutInfoMessages } from './messages'
import { Terms, StyledLink, CheckoutInfoCenteredSpinner } from './styles'
import { currentRootDomainIdSelector } from 'features/rootDomains/selectors'
import { Checkbox } from 'components/Input'
import { getInvoiceThunk } from '../slice'
import { subscriptionHomePriceSelector } from 'features/home/selectors'
import { PriceV2 } from 'features/home/types'

function getLinkFor(href: string) {
  return function Link(chunks: string) {
    return (
      <StyledLink href={href} target="_blank" rel="noreferrer">
        {chunks}
      </StyledLink>
    )
  }
}

interface CheckoutInfoProps {
  setIsAcceptPrivacy: Dispatch<boolean>
  isShowEssentialsPlan?: boolean
  networkPrice?: PriceV2
  quantity?: number
  setAmountDue: Dispatch<SetStateAction<number>>
}

function CheckoutInfo({
  isShowEssentialsPlan = true,
  setIsAcceptPrivacy,
  networkPrice,
  quantity,
  setAmountDue,
}: CheckoutInfoProps) {
  const dispatch = useAppDispatch()
  const { homeId } = useHomeRouteParams()
  const isUpcomingInvoiceLoaded = useAppSelector(
    upcomingInvoiceSelectors.isFinished
  )
  const isUpcomingInvoiceFetching = useAppSelector(
    upcomingInvoiceSelectors.isFetching
  )
  const price = useAppSelector(subscriptionHomePriceSelector.data)
  const currentRootId = useAppSelector(currentRootDomainIdSelector)

  const { id: priceId } = networkPrice ?? price ?? ''

  const handleChangeCheckbox = useCallback(
    (event) => {
      setIsAcceptPrivacy(event.target.checked)
    },
    [setIsAcceptPrivacy]
  )

  const dataFetchedRef = useRef(false)

  useEffect(() => {
    if (dataFetchedRef.current) return
    dataFetchedRef.current = true

    if (currentRootId) {
      dispatch(
        getInvoiceThunk(
          { priceId, promocode: '', quantity },
          homeId,
          currentRootId
        )
      )
    }
  }, [dispatch, priceId, homeId, currentRootId, quantity])

  return (
    <>
      {isUpcomingInvoiceLoaded ? (
        <>
          {!isUpcomingInvoiceFetching ? (
            (price !== null || !isShowEssentialsPlan ) ? (
              <CheckoutAmounts
                currentPrice={price}
                isShowEssentialsPlan={isShowEssentialsPlan}
                setAmountDue={setAmountDue}
              />
            ) : (
              <>
                <h3>Host configuration unknown, please upgrade to continue.</h3>
              </>
            )

          ) : (
            <CheckoutInfoCenteredSpinner>
              <Spinner size={2} />
            </CheckoutInfoCenteredSpinner>
          )}

          {(price !== null || !isShowEssentialsPlan) && (
            <Terms>
              <Checkbox onChange={handleChangeCheckbox} />
              <Secondary color={theme.colors.otterWarmBlack}>
                <FormattedMessage
                  {...checkoutInfoMessages.termsAndPolicy}
                  values={{
                    termsAndConditions: getLinkFor(TERMS_AND_CONDITIONS_LINK),
                  }}
                />
                {true && (
                  <>
                    &nbsp;
                    <FormattedMessage
                      {...checkoutInfoMessages.termsAndPolicyNetwork}
                      values={{
                        termsAndConditionsJuniper: getLinkFor(
                          JUNIPER_TERMS_AND_CONDITIONS_LINK
                        ),
                      }}
                    />
                  </>
                )}
              </Secondary>
            </Terms>
          )}
        </>
      ) : (
        <SpinnerCentered />
      )}
    </>
  )
}

export default CheckoutInfo
